export const addresses = {
  font: "0xF3636358069588D2A16a81d27e7e8cB15Eb3827B",
};
